import React from 'react';

function AlertDialog({ show, message, onClose, type = 'info' }) {
  if (!show) return null;

  return (
    <dialog open={show} className={`alert-dialog ${type}-alert`}>
      <p>{message}</p>
      <button onClick={onClose}>OK</button>
    </dialog>
  );
}

export default AlertDialog; 